import React from 'react';
import {iconName, qualify} from '@packages/systems/wfdl-Qualified';
import {Atom, ContextType, Plugins, withSystem} from '@packages/systems/wfdl';
import {
  CLASS_NAME_DYNAMIC_LIST_ITEM,
  CLASS_NAME_DYNAMIC_LIST_COLUMN,
  CLASS_NAME_DYNAMIC_LIST_REPEATER_ITEM,
  getColumnNumberClassName,
} from './constants';
import {
  TListOfElement,
  TNumber,
  TRecord,
  TText,
} from '@packages/systems/wfdl-ast';
import {weakMemo} from '@packages/utilities/memo';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';
import {
  getChildren,
  getInPojo,
  getNumberOrElse,
} from '@packages/utilities/data-utils';

const updateContextInsideItem = weakMemo(
  (context: ContextType): ContextType => context.set('insideItem', true)
);

const DynamoItem = Atom.createRender(
  ({attributes, classes, generateAttributes, renderChild, data, context}) => {
    const gridSize = getNumberOrElse(getInPojo(data, ['dyn', 'grid']), 12);
    const isInsideRepeaterContext =
      context.get('repeaterSlugPath', []).length > 0;

    let itemClasses = classes.push(CLASS_NAME_DYNAMIC_LIST_ITEM);

    if (isInsideRepeaterContext) {
      itemClasses = itemClasses.push(CLASS_NAME_DYNAMIC_LIST_REPEATER_ITEM);
    }

    if (gridSize !== 12) {
      itemClasses = itemClasses.push(
        CLASS_NAME_DYNAMIC_LIST_COLUMN,
        getColumnNumberClassName(gridSize)
      );
    }

    const listItemAttributes = attributes.set('role', 'listitem');

    return (
      <div {...generateAttributes(listItemAttributes, itemClasses)}>
        {getChildren(data).map((child) =>
          renderChild(child, updateContextInsideItem(context))
        )}
      </div>
    );
  }
);

const config = createIntegratedAtom({
  displayName: 'Collection Item',
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Dynamo'), iconName('CollectionItem')),
  },
  showEmpty: true,
  constraints: {
    pinToParent: true,
  },
  render: DynamoItem,
  fields: {
    dyn: withSystem(
      {private: true},
      TRecord({
        type: withSystem({private: true, defaultValue: 'item'}, TText),
        grid: withSystem({private: true, defaultValue: 12}, TNumber),
      })
    ),
    children: TListOfElement,
  },
});

export default config;
